export { ItModal } from './it-modal.js';
import 'lit/directive.js';
import 'lit';
import 'lit/decorators.js';
import 'lit/directives/class-map.js';
import 'lit/directives/if-defined.js';

const MODAL_SIZES = ['sm', 'lg', 'xl'];
const MODAL_POSITIONS = ['center', 'left', 'right'];
const MODAL_VARIANTS = ['alert', 'popconfirm', 'link-list'];

export { MODAL_POSITIONS, MODAL_SIZES, MODAL_VARIANTS };
//# sourceMappingURL=index.js.map
